eval("define(\'oroui/js/app/routes\',[],function() {\n    \'use strict\';\n\n    return [\n        [\'*pathname\', \'page#index\']\n    ];\n});\n\n//# sourceURL=/home/siacemlapazcampo/public_html/buenafe/siacem/web/bundles/oroui/js/app/routes.js");

